module.exports = __webpack_public_path__ + "static/media/background4.bca0cd3d.jpg";